//Temporary until resident photos are available through the API
//Images are under @/assets/patient-images
export const RoomNumbersWithPatientPhotos = ['4', '12', '17', '38', '102']
